import React from "react";
var ErrorMsg = function (props) {
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "errormsg-box" }, props.title)));
};
export default ErrorMsg;
